import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';
import moment from "moment/moment";
import { formatMoneda } from '../../../../../util/varios';

const headCells = [
  {
    id: "pendiente",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Pendiente",
    textAlign: "center",
  },
  {
    id: "fecSalida",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fec. Salida",
    textAlign: "center",
  },
  {
    id: "fecInicioPeriodo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fec. Inicio Período",
    textAlign: "center",
  },
  {
    id: "fecFinPeriodo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fec. Fin Período",
    textAlign: "center",
  },
  {
    id: "montoPagado",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Monto Pagado",
    textAlign: "center",
  },
];
export default function TablaVacaciones(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [activate, setActivate] = useState(false);

  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  const seleccionarVacaciones = (codIntegrante) => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let nomtab = 'vacacionesinteg';
    let nomid = 'codint';
    let bloquear = true;

    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codIntegrante}&nomtab=${nomtab}&nomid=${nomid}&bloquear=${bloquear}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || 'Error al cargar el registro',
          icono: 'error'
        });
      })
      .finally(() => setActivate(false));
  };

  useEffect(() => {
    console.log("Cargando vacaciones para codIntegrante:", props.codIntegrante);
    seleccionarVacaciones(props.codIntegrante);

  }, [props.codIntegrante]);

  return (
    <div className="col-12 m-0 p-0 d-flex">
      <TblContainer>
        <TblHead />
        <tbody>
          {records &&
            recordsAfterPagingAndSorting().map((item, index) => (
              <tr key={index}>
                <td className="text-center">{moment.utc(item.fecsal).format('DD-MM-YYYY')}</td>
                <td className="text-center">{moment.utc(item.fecret).format('DD-MM-YYYY')}</td>
                <td className="text-center">{moment.utc(item.feciniper).format('DD-MM-YYYY')}</td>
                <td className="text-center">{moment.utc(item.fecfinper).format('DD-MM-YYYY')}</td>
                <td className="text-center">{formatMoneda(item.monpag.toString()
                  .replace(",", "")
                  .replace(".", ","),
                  ",",
                  ".",
                  2
                )}</td>
              </tr>
            ))}
        </tbody>
      </TblContainer>
    </div>
  );
}
